import { createContext, Dispatch, FC, useContext, useReducer } from 'react';

export interface HeaderDrawerState {
  isOpen: boolean;
}

export type HeaderDrawerAction = { type: 'TOGGLE' };

const initialState: HeaderDrawerState = {
  isOpen: false,
};

function reducer(state: HeaderDrawerState, action: HeaderDrawerAction): HeaderDrawerState {
  switch (action.type) {
    case 'TOGGLE':
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    default:
      return state;
  }
}

const HeaderDrawerStateContext = createContext<HeaderDrawerState>(initialState);

const HeaderDrawerDispatchContext = createContext<Dispatch<HeaderDrawerAction> | undefined>(undefined);

export const HeaderDrawerProvider: FC = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <HeaderDrawerStateContext.Provider value={state}>
      <HeaderDrawerDispatchContext.Provider value={dispatch}>{children}</HeaderDrawerDispatchContext.Provider>
    </HeaderDrawerStateContext.Provider>
  );
};

export function useHeaderDrawerState(): HeaderDrawerState {
  const context = useContext(HeaderDrawerStateContext);

  if (context === undefined) {
    throw new Error(`useHeaderDrawerState must be used inside a HeaderDrawerProvider`);
  }

  return context;
}

export function useHeaderDrawerDispatch(): Dispatch<HeaderDrawerAction> {
  const context = useContext(HeaderDrawerDispatchContext);

  if (context === undefined) {
    throw new Error(`useHeaderDrawerDispatch must be used inside a HeaderDrawerProvider`);
  }

  return context;
}
